import { Component, Injector, OnInit} from '@angular/core';
import { ChecklistDatabaseService } from './services/check-list-database.service';
import { UserNotificationSettingsComponent } from './user-notification-settings.component';
import { ActivatedRoute } from '@angular/router';
import { MedicalCenterService } from 'src/app/services/medical-center-service';

@Component({
  selector: 'app-user-notification-settings',
  templateUrl: './user-notification-settings.component.html',
  styleUrls: ['./user-notification-settings.component.scss'],
  providers: [ChecklistDatabaseService]
})
export class MedicalCenterNotificationSettingsComponent extends UserNotificationSettingsComponent implements OnInit {

  constructor(
    protected injector: Injector,
    private route: ActivatedRoute,
    private medicalCenterService: MedicalCenterService
  ) {
    super(injector);
    this.medicalCenterID = parseInt(this.route.snapshot.paramMap.get('id'));
    this.medicalCenterName = this.medicalCenterService.getMedicalCenterByID(this.medicalCenterID);
  }

  async ngOnInit() {
    const notificationSettings = await this.apiService.getMedicalCenterNotificationSettings(this.medicalCenterID).toPromise();
    if (notificationSettings.success == true) {
      this.notificationSettings = {
        GeneralNotificationSetting: notificationSettings.data.GeneralNotificationSetting.map((element) => {
          return {
            id: element.GeneralNotificationSettingType,
            selection: element.GeneralNotificationSettingValue,
            sound: element.GeneralNotificationSettingSound,
            vibration: element.GeneralNotificationSettingVibration,
          };
        }),
        UrgentAlertTemplateSetting: notificationSettings.data.UrgentAlertTemplateSetting.map((element) => {
          return {
            id: element.UrgentAlertTemplateSettingUrgentAlertTemplateID,
            selection: element.UrgentAlertTemplateSettingValue,
            sound: element.UrgentAlertTemplateSettingSound,
            vibration: element.UrgentAlertTemplateSettingVibration
          };
        }),
        NewsAnnotationSetting: notificationSettings.data.NewsAnnotationSetting.map((element) => {
          return {
            id: element.NewsAnnotationSettingNewsAnnotationID,
            selection: element.NewsAnnotationSettingValue,
            sound: element.NewsAnnotationSettingSound,
            vibration: element.NewsAnnotationSettingVibration
          };
        }
        )
      };
    } else {
      alert('Something went wrong!');
    }
  } 

  async submit() {
    const unselectedUrgent = this.getDeselectedUrgentAlertTemplates();
    const unselectedNews = this.getDeselectedNewsAnnotations();
    const unselectedGlobal = this.getDeselectedGlobal();
    const data = {
      UrgentAlertTemplateSetting: unselectedUrgent,
      NewsAnnotationSetting: unselectedNews,
      GeneralNotificationSetting: unselectedGlobal
    };
    const result = await this.apiService.saveMedicalCenterNotificationSettings(this.medicalCenterID, data).toPromise();
    if (result.success !== true) {
      alert('Something went wrong!');
    } else {
      alert('Changes successfully saved');
      this.saveNotificationSetting.next(true);
    }
  }

}
